import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import Slider from 'react-slick';
import CSIntroImage1 from "../../images/printer-img.png";
import CSERPImage1 from "../../images/erp-img-1.png";
import CSERPImage2 from "../../images/erp-img-2.png";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import Parallax from "../common/utils/animations/parallax";

export default function FlexprintCsIntro(props) {
  const [isMobile, setisMobile] = useState(false);

  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { scrollY } = useViewportScroll();
  const yOffset = 150;
  const easing = [0.42, 0, 0.58, 1];
  const ref = useRef();

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
    setisMobile(window.innerWidth <= 1023);
  };

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const y = useTransform(scrollY, [elementTop - clientHeight * 0.9, elementTop - clientHeight / 4], [yOffset, 0], easing);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
    fade: true,
    speed: 1000,
    cssEase: 'linear'
  };
  return (
    <div className="cs-intro-section section-gap fp-cs-intro-section" onLoad={setValues}>
      <div className="fp-cs-intro-top section-gap">
        <div className="container-small">
          <div className="intro-inner">
            <h3 className="h3">Unlocking the ‘Digital’ Opportunity</h3>
            <p>Our client is one of the largest managed print services providers in the United States, with thousands of business customers and 500 million+ in revenue across the country. With their thousands of IoT devices in the field, they had a massive opportunity to automate processes, improve customer experiences, and launch new digital products and services. </p>
          </div>
        </div>
      </div>
      <div ref={ref} className="fp-cs-intro-middle section-gap">
        <div className="fp-intro-content">
          <div className="container">
            <div className="fp-intro-content-inner">
              <h3 className="h3">The Challenge </h3>
              <p>FlexTG's entire business was heavily dependent on legacy ERP systems, and replacing them was not an option. Without any documentation, it was a daunting task to build on top of this beast. </p>

              <p>The company has deployed thousands of printer devices at customer sites. Their service and management were very manual, unpredictable and labor-intensive. While each device could emit millions of logs and the logs could be used to automate the manual processes, it would require a massively scalable digital platform to collect, analyze, and monetize this Internet of Things (IoT) opportunity.</p>
            </div>
          </div>
        </div>
        <div className="fp-intro-image">
          <motion.img style={{ y }} src={CSIntroImage1} className="intro-large-image" title="Scalable Digital Platform" alt="scalable digital platform" />
        </div>
      </div>
      <InView as="div" className="fp-cs-intro-bottom" onChange={(inView) => setIsVisible(inView)} threshold={[0.05]}>
        <div className="container-small">
          <div className="intro-inner section-gap-small">
            <h2 className="theme-color-title dark-purple-color">{isVisible ? <HeaderAnim header="ERP INTEGRATION & MODERNIZATION" /> : ""}</h2>
            <h3 className="h3">Removing legacy roadblocks</h3>
            <p>Flexprint's majority of business processes are managed with a legacy desktop-based ERP system. In order to build any digital system, we first had to figure out a way to interact with the ERP. The system did not offer any APIs or integration points, and there was no documentation.</p>

            <p>Drawing on our years of experience with legacy and ERP systems, with two weeks and ad-hoc analysis, our team figured out the data model, services, and ins-and-outs of the client's legacy ERP system. It came up with a solid strategy to orchestrate it for building new digital services. It paved the way to shape Flexprint's digital future.</p>
          </div>
          <div className="fp-intro-bottom-image">
            {isMobile && <> <Slider {...settings}>
              <img src={CSERPImage1} title="Removing Legacy Roadblocks" alt="removing legacy roadblocks" />
              <img src={CSERPImage2} title="Removing Legacy Roadblocks" alt="removing legacy roadblocks" />
            </Slider></>}
            {!isMobile && <>
              <Parallax id="Removing-Legacy-Roadblocks-1" triggers={[1, 0.7]} opacity={true} length={100}>
                <motion.img src={CSERPImage1} title="Removing Legacy Roadblocks" alt="removing legacy roadblocks" />
              </Parallax>
              <Parallax id="Removing-Legacy-Roadblocks-2" triggers={[1, 0.7]} opacity={true} length={100}>
                <motion.img src={CSERPImage2} title="Removing Legacy Roadblocks" alt="removing legacy roadblocks" />
              </Parallax>
            </>}
            <small>LEGACY DESKTOP BASE ERP THAT DID NOT OFFER ANY APIS OR INTEGRATIONS</small>
          </div>
        </div>
      </InView>
    </div>
  );
}